<template>
  <div v-if="legacySubscriptions && apparatusDetails">
    <b-row align-h="center" class="mb-0 pb-0 current-plan" no-gutters>
      <b-col class="text-center">
        <div align-h="around" class="row mb-3 ml-3 mr-3">
          <p class="text-center plan-details-header-notice mx-auto">
            {{ $t('xUpgradeToNewSubscriptionTitle') }}
          </p>
          <p class="text-center plan-details-header" data-test-hook="new-plan-with-upgrade-text">
            {{
              $t('xUpgradeToNewSubscriptionText', {
                0: getCurrencyString(selectedProduct.cost),
                1: closestNextBillingDate
              })
            }}
          </p>
        </div>
      </b-col>
    </b-row>
    <SubscriptionCard
      :subscription-product="selectedProduct"
      :existing-apparatuses="[]"
      :apparatuses-to-add="apparatusesOnNewPlan"
      :is-new-plan="true"
      :monthly-paid-product="monthlyPaidProduct"
      :annual-paid-product="annualPaidProduct"
      :hide-badge="true"
      :is-highlighted="true"
      @setSelectedProduct="setSelectedProduct"
    />
    <b-row no-gutters class="mt-3">
      <b-col cols="12" class="float-left">
        <b-button
          variant="warning"
          class="w-100"
          :disabled="isCreatingPurchaseIntent || isCancellingLegacyPlans"
          @click="immediateCancelLegacyAndProceedToPayment"
          data-test-hook="subscription-new-tank-with-basic-confirm-plan-button"
        >
          {{ $t('xUpgradeNow') }}
          <b-spinner class="ml-2" v-if="isCreatingPurchaseIntent || isCancellingLegacyPlans" />
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { isFuelMonitorV2 } from '../../../utils/apparatus'
import SubscriptionCard from './Common/SubscriptionCard.vue'
import * as Constants from '@/constants'

export default {
  props: [
    'legacySubscriptions',
    'apparatusDetails',
    'selectedProduct',
    'monthlyPaidProduct',
    'annualPaidProduct',
    'isCreatingPurchaseIntent',
    'apparatusList',
    'accountData'
  ],
  emits: ['openPayment', 'setSelectedProduct'],
  components: {
    SubscriptionCard
  },
  data() {
    return {
      apparatusesOnNewPlan: [],
      isCancellingLegacyPlans: false
    }
  },
  mounted() {
    if (this.apparatusList && this.apparatusDetails) {
      // assume that, since there are active legacy subs, there are no new subs
      // therefore we can assume that ALL eligible (non-DM and non-v1) products should be subscribed to the new plan
      this.apparatusesOnNewPlan = this.apparatusList?.filter(app => {
        return (
          (app.type === Constants.HsbApparatusType ||
            (app.type === Constants.FuelTankApparatusType && isFuelMonitorV2(app))) &&
          !app.isDealerManaged
        )
      })

      if (!this.apparatusesOnNewPlan.some(app => app.apparatusId === this.apparatusDetails.id)) {
        this.apparatusesOnNewPlan = [...this.apparatusesOnNewPlan, this.apparatusDetails]
      }
    }
  },
  methods: {
    setSelectedProduct(product) {
      this.$emit('setSelectedProduct', product)
    },
    async immediateCancelLegacyAndProceedToPayment() {
      if (this.accountData?.organizationId) {
        this.isCancellingLegacyPlans = true
        const immediateCancelBatch = []
        this.legacySubscriptions.forEach(legacySub => {
          if (legacySub.status === Constants.SubscriptionActive) {
            immediateCancelBatch.push(
              this.$store.dispatch('cancelSubscriptionProductImmediately', {
                organizationId: this.accountData.organizationId,
                store: Constants.WebSubscriptionStore,
                productId: legacySub.productId,
                apparatusId: legacySub.apparatusId
              })
            )
          }
        })

        Promise.all(immediateCancelBatch)
          .then(() => {
            this.$emit('openPayment')
          })
          .catch(() => {
            this.$store.dispatch('displayToast', {
              title: this.$t('xSomethingWentWrong'),
              message: this.$t('xPleaseTryAgain'),
              variant: 'danger'
            })
          })
          .finally(() => {
            this.isCancellingLegacyPlans = false
          })
      }
    }
  },
  computed: {
    closestNextBillingDate() {
      let closestDate
      if (this.legacySubscriptions?.length > 0) {
        this.legacySubscriptions.forEach(sub => {
          const renewDate = this.$moment(sub.nextBillingDate)

          if (sub.status === Constants.SubscriptionActive) {
            if (!closestDate) {
              closestDate = renewDate
            } else if (renewDate.isAfter(new Date()) && renewDate.isBefore(closestDate)) {
              closestDate = renewDate
            }
          }
        })
      }

      if (!closestDate) {
        closestDate = this.$moment(new Date())
      }

      return closestDate.format(this.$t('xShortDate'))
    }
  }
}
</script>
<style lang="scss">
.current-plan {
  .plan-details-header {
    font-size: 14px;
    line-height: 24px;
    color: var(--carbon-900);
  }
  .plan-details-header-notice {
    font-size: 18px;
    line-height: 24px;
    font-weight: 1000;
    color: var(--carbon-900);
  }
}
</style>
